import { Subject, Observable } from 'rxjs';

const ChangeLangSubject$$ = new Subject();

interface MessageSender {
  (lang: string): void;
}

interface MessageObservable {
  (): Observable<any>;
}

interface Messaging {
  sendMessage: MessageSender;
  onMessage: MessageObservable;
}

export const ChangeLang$$: Messaging = {
  sendMessage: (lang: string) => ChangeLangSubject$$.next(lang),
  onMessage: () => ChangeLangSubject$$.asObservable(),
};
